import styled from 'styled-components';
import {Link} from '@aboutyou/router';

export const UnstyledLink = styled(Link)`
  &,
  &:hover,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`;
